import { RequestDto } from '@hermes/domains'
import { RequestDetailsInterface } from '@hermes/types'
import { getPublicConfigVariable } from '@lib/utils/getConfigVariable'
import { Region } from '@lib/utils/getRegionFromLocale'
import { CookieValueTypes } from 'cookies-next'

const legacyApiPath = getPublicConfigVariable('LEGACY_API_URL')
const hermesApiPath = getPublicConfigVariable('HERMES_API_URL')

export const sendMeetupRequest = ({
  userId,
  delivery = 'meetup',
  price,
  saleId,
  sellerId,
  country,
  message,
  token
}: {
  userId: number
  delivery?: string
  price: number
  saleId: number
  sellerId: number
  country: string
  token: CookieValueTypes
  message: string
}): Promise<{
  data: RequestDetailsInterface
  code?: number
  message?: string
}> =>
  fetch(`${legacyApiPath}/requests/`, {
    method: 'POST',
    body: JSON.stringify({
      userId,
      delivery,
      price,
      saleId,
      sellerId,
      message
    }),
    headers: {
      country,
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  }).then((res) => res.json())

export const getRequestByUuid = async (requestUuid: string, region: Region) => {
  const response = await fetch(`${hermesApiPath}/v1/${region}/order/${requestUuid}`, {
    cache: 'no-store'
  })
  const rawData: { data: RequestDto } = await response.json()
  return rawData.data
}

export const acceptRequestById = async (
  requestId: number,
  data: { shippingTime: string; addressId: number },
  region: Region,
  token: CookieValueTypes
) => {
  const response = await fetch(`${legacyApiPath}/requests/${requestId}/approve`, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      Country: region.toUpperCase(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data),
    cache: 'no-store'
  })
  if (!response.ok) {
    const body = await response.json()
    throw new Error(body.message || 'Failed to accept request')
  }
  return response.json()
}
